/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Tag_TitleInputs */

const en_directory_taxonomy_index_tag_title = /** @type {(inputs: Directory_Taxonomy_Index_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore products by tag`)
};

const zh_directory_taxonomy_index_tag_title = /** @type {(inputs: Directory_Taxonomy_Index_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按标签探索产品`)
};

/**
* | output |
* | --- |
* | "Explore products by tag" |
*
* @param {Directory_Taxonomy_Index_Tag_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_tag_title = /** @type {((inputs?: Directory_Taxonomy_Index_Tag_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Tag_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_tag_title(inputs)
	return zh_directory_taxonomy_index_tag_title(inputs)
});
export { directory_taxonomy_index_tag_title as "directory.taxonomy_index.tag.title" }